(() => {
  'use strict';
  const sweaterColors = {
    Beige:'#efdcbe', White:'#e9e7e8', 'Rose Pink':'#dca0a7', Khaki:'#ad8c7b',
    'Dusty Blue':'#7ea9c2', Orange:'#ed6604', Green:'#447d5a', Black:'#141416',
    Navy:'#0e1f3d', 'Light Pink':'#fabfc1', Red:'#ab0224',
    'Light Purple':'#ccb3dd', Mint:'#61d4a8', Mustard:'#e48b1d'
  };
  const threads = {
    Blue:['#203c69','#709fbb'], Black:['#242424','#696969'],
    Brown:['#775842','#be9b7b'], Green:['#476e60','#8fb3a2'],
    Pink:['#a75172','#e1a0b5'], Purple:['#6d4c91','#b693ca'],
    Red:['#a2324e','#ce7e8e'], Yellow:['#ad7619','#e4ba57']
  };
  const titleCase = value => value.toLocaleLowerCase().replace(/(^|[\s'-])([^\s'-])/gu, (_, before, char) => before + char.toLocaleUpperCase());
  function splitName(value) {
    const words = value.trim().replace(/\s+/g, ' ').split(' ').filter(Boolean);
    const first = words.shift();
    return {first:(first || 'BROOKS').toLocaleUpperCase(), last:titleCase(words.join(' ') || (first ? '' : 'Jones'))};
  }
  function bestImage(img) {
    const srcset = img.getAttribute('srcset') || '';
    const candidates = srcset.split(',').map(part => {
      const match = part.trim().match(/^(\S+)\s+(\d+)w$/);
      return match ? {url:match[1], width:Number(match[2])} : null;
    }).filter(Boolean).sort((a,b) => b.width - a.width);
    return candidates[0]?.url || img.getAttribute('src') || img.currentSrc;
  }
  function start() {
    const root = document.querySelector('[id^="MainProduct-"]:has(.gg-ns-personalization [id^="GGName-"])');
    const sourceTemplate = document.getElementById('GGSTSweaterSources');
    if (!root || !sourceTemplate || root.querySelector('.gg-bn-gallery')) return;
    const nameField = root.querySelector('.gg-ns-personalization [id^="GGName-"]');
    const galleries = [...root.querySelectorAll('.main-product__container>.product--thumbnail_slider,.main-product__container>.product--thumbnail_slider__mobile')];
    let gallery = galleries.find(node => getComputedStyle(node).display !== 'none');
    if (!nameField || !gallery || !root.querySelector('variant-selects')) return;

    const seen = new Set();
    const photoSource = galleries.find(node => node.querySelector('.swiper-slide img'));
    const photos = [...photoSource.querySelectorAll('.swiper-slide img')].map(img => ({
      src:img.getAttribute('src') || img.currentSrc,
      srcset:img.getAttribute('srcset') || '', high:bestImage(img), alt:img.alt || 'Personalized baby sweater'
    })).filter(photo => photo.src && !seen.has(photo.src) && seen.add(photo.src));
    if (!photos.length) return;

    const controls = root.querySelector('.gg-ns-personalization');
    const nameLabel = controls.querySelector(`label[for="${CSS.escape(nameField.id)}"]`);
    if (nameLabel) nameLabel.textContent = "Baby's full name";
    nameField.placeholder = 'e.g. Brooks Jones';
    nameField.autocomplete = 'off';
    const nameHelp = controls.querySelector('p');
    if (nameHelp) {
      nameHelp.textContent = 'The first name appears in uppercase Georgia Bold; the remaining name appears in Dancing Script. Check the spelling before adding to cart.';
      nameHelp.classList.add('gg-bn-name-help');
    }
    const formId = nameField.getAttribute('form') || root.querySelector('form[action*="/cart/add"]')?.id;
    const styles = document.createElement('fieldset');
    styles.className = 'gg-bn-style';
    const legend = document.createElement('legend');
    legend.textContent = 'Color Style:';
    const grid = document.createElement('div');
    grid.className = 'gg-bn-style__grid';
    Object.entries(threads).forEach(([name,[main,script]], index) => {
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'radio'; input.name = 'properties[Color Style]'; input.value = name;
      if (formId) input.setAttribute('form', formId);
      if (index === 0) input.checked = true;
      const tile = document.createElement('span'); tile.className = 'gg-bn-style__tile';
      const pair = document.createElement('span'); pair.className = 'gg-bn-style__pair';
      [main,script].forEach(color => {const dot=document.createElement('i'); dot.style.setProperty('--color', color); pair.append(dot)});
      tile.append(pair, document.createTextNode(name)); label.append(input,tile); grid.append(label);
    });
    const styleHelp = document.createElement('p');
    styleHelp.className = 'gg-bn-style__help';
    styleHelp.textContent = 'Choose the two embroidery thread colors shown in the preview.';
    styles.append(legend,grid,styleHelp);
    controls.after(styles);

    const host = document.createElement('div');
    host.className = 'gg-bn-gallery';
    host.innerHTML = '<div class="gg-bn-thumbs" aria-label="Product image thumbnails"></div><div class="gg-bn-main"><div class="gg-bn-stage" role="button" tabindex="0" aria-label="Enlarge current product image"><img alt=""><canvas width="1254" height="1254" hidden role="img" aria-label="Personalized sweater preview"></canvas><span class="gg-bn-badge" hidden>Live name preview</span><button class="gg-bn-arrow gg-bn-arrow--prev" type="button" aria-label="Previous image">‹</button><button class="gg-bn-arrow gg-bn-arrow--next" type="button" aria-label="Next image">›</button></div><p class="gg-bn-caption" aria-live="polite" hidden></p></div>';
    const thumbs = host.querySelector('.gg-bn-thumbs');
    const stage = host.querySelector('.gg-bn-stage');
    const photo = stage.querySelector('img');
    const canvas = stage.querySelector('canvas');
    const ctx = canvas.getContext('2d', {willReadFrequently:true});
    const badge = stage.querySelector('.gg-bn-badge');
    const caption = host.querySelector('.gg-bn-caption');
    const previewIndex = photos.length;
    const buttons = [];
    photos.forEach((item,index) => {
      const button = document.createElement('button');
      button.type='button'; button.className='gg-bn-thumb';
      button.setAttribute('aria-label',`Product image ${index+1}`);
      const image=document.createElement('img'); image.src=item.src; image.alt=item.alt; image.loading='lazy';
      button.append(image); button.addEventListener('click',()=>show(index));
      thumbs.append(button); buttons.push(button);
    });
    const previewButton=document.createElement('button');
    previewButton.type='button'; previewButton.className='gg-bn-thumb';
    previewButton.dataset.preview='';
    previewButton.setAttribute('aria-label','Live name preview');
    const previewImage=document.createElement('img'); previewImage.alt='Live preview of your embroidered name';
    previewButton.append(previewImage); previewButton.addEventListener('click',()=>show(previewIndex));
    thumbs.append(previewButton); buttons.push(previewButton);

    const original = galleries.flatMap(node => [...node.children]);
    original.forEach(node => node.style.display='none');
    gallery.prepend(host);
    const garmentSources = new Map([...sourceTemplate.content.querySelectorAll('img')].map(img => [img.dataset.sweaterColor, img.getAttribute('src')]));
    let selected = 0, currentColor = 'White';
    const garmentCache = new Map();
    const dialog=document.createElement('dialog'); dialog.className='gg-bn-dialog';
    dialog.innerHTML='<button type="button" aria-label="Close enlarged image">×</button><img alt="Enlarged product image">';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
    const large=dialog.querySelector('img');

    function sweaterColor() {
      const value=root.querySelector('input[name="Color Sweater"]:checked')?.value?.replace(/^\d+\.\s*/, '') || 'White';
      return sweaterColors[value] ? value : 'White';
    }
    function garmentPhoto(color) {
      if (!garmentCache.has(color)) {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => { previewButton.hidden = false; paintPreview(); };
        image.onerror = () => {
          // A failed earlier selection must not hide a newer, working selection.
          if (sweaterColor() !== color) return;
          previewButton.hidden = true;
          if (selected === previewIndex) show(0);
        };
        garmentCache.set(color, image);
        image.src = garmentSources.get(color);
      }
      const image = garmentCache.get(color);
      return image.complete && image.naturalWidth ? image : null;
    }
    function fittedFont(text, family, weight, startSize, maxWidth) {
      let size=startSize;
      while(size>48){
        ctx.font=`${weight} ${size}px ${family}`;
        if(ctx.measureText(text).width<=maxWidth)break;
        size-=2;
      }
      return size;
    }
    function paintPreview() {
      currentColor=sweaterColor();
      const garment=garmentPhoto(currentColor);
      canvas.setAttribute('aria-busy',String(!garment));
      if(!garment){caption.textContent=`Loading ${currentColor} sweater preview…`;return;}
      const style=root.querySelector('.gg-bn-style input:checked')?.value || 'Blue';
      const [main,script]=threads[style] || threads.Blue;
      const name=splitName(nameField.value);
      ctx.clearRect(0,0,1254,1254);
      ctx.fillStyle='#fff'; ctx.fillRect(0,0,1254,1254);
      ctx.drawImage(garment,0,0,1254,1254);
      ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.lineJoin='round';
      fittedFont(name.first,'Georgia, serif','700',108,530);
      const firstMetrics=ctx.measureText(name.first);
      const firstRight=627+firstMetrics.actualBoundingBoxRight;
      ctx.fillStyle=main; ctx.fillText(name.first,627,530);
      if(name.last){
        fittedFont(name.last,'"Dancing Script", cursive','400',100,Math.min(530,firstMetrics.width));
        ctx.textAlign='right';
        ctx.fillStyle=script; ctx.fillText(name.last,firstRight,640);
        ctx.textAlign='center';
      }
      caption.textContent=`${currentColor} sweater · ${name.first}${name.last?' / '+name.last:''} · ${style} embroidery`;
      canvas.setAttribute('aria-label',caption.textContent);
      const rendered=canvas.toDataURL('image/png');
      previewImage.src=rendered;
      if(dialog.open && selected===previewIndex)large.src=rendered;
    }
    function show(index) {
      selected=(index+buttons.length)%buttons.length;
      const live=selected===previewIndex;
      photo.hidden=live; canvas.hidden=!live; badge.hidden=!live; caption.hidden=!live;
      if(!live){
        const item=photos[selected];
        photo.src=item.src; photo.srcset=item.srcset;
        photo.sizes='(min-width: 990px) 50vw, 100vw'; photo.alt=item.alt;
      }
      buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===selected)));
      if(live)paintPreview();
    }
    function zoom() {
      large.src=selected===previewIndex?canvas.toDataURL('image/png'):photos[selected].high;
      large.alt=selected===previewIndex?caption.textContent:photos[selected].alt;
      dialog.showModal();
    }
    stage.addEventListener('click',event=>{if(event.target.closest('.gg-bn-arrow'))return;zoom()});
    stage.addEventListener('keydown',event=>{if((event.key==='Enter'||event.key===' ')&&event.target===stage){event.preventDefault();zoom()}});
    stage.querySelector('.gg-bn-arrow--prev').addEventListener('click',event=>{event.stopPropagation();show(selected-1)});
    stage.querySelector('.gg-bn-arrow--next').addEventListener('click',event=>{event.stopPropagation();show(selected+1)});
    let startX=0;
    stage.addEventListener('touchstart',event=>{startX=event.changedTouches[0].clientX},{passive:true});
    stage.addEventListener('touchend',event=>{const distance=event.changedTouches[0].clientX-startX;if(Math.abs(distance)>45)show(selected+(distance<0?1:-1))},{passive:true});
    nameField.addEventListener('input',()=>{paintPreview();show(previewIndex)});
    styles.addEventListener('change',()=>{paintPreview();show(previewIndex)});
    root.addEventListener('change',event=>{
      if(event.target.matches('input[name="Color Sweater"]')){
        paintPreview();show(previewIndex);
        setTimeout(paintPreview,300);
      }
    });
    const onResize=()=>{
      const next=galleries.find(node=>getComputedStyle(node).display!=='none');
      if(next && next!==gallery){gallery=next;gallery.prepend(host)}
    };
    window.addEventListener('resize',onResize);
    // Start on the live preview using the merchant's actual selected-color photo.
    show(previewIndex);
    if(document.fonts)document.fonts.load('400 100px "Dancing Script"').then(paintPreview).catch(()=>{});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  let pending=false;
  new MutationObserver(()=>{
    if(pending)return;
    pending=true;
    requestAnimationFrame(()=>{pending=false;start()});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
